export default class VehicleCheck {

    constructor(data) {
        this.id = null;
        this.vehicleId = null;
        this.category = null;
        this.categoryId = null;
        this.name = null;
        this.state = null;
        this.reviser = null;
        this.description = null;
        this.date = null;
        this.isDefault = false;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/vehiclecheck.model.js